import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { API_WHITEBOARD } from '../../../../../modules/API/constants_ts';
import apiManagerWB from '../../../api/apiManagerWB';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import IconAddWhiteboard from './IconAddWhiteboard';
const useStyles = makeStyles()(theme => {
    return {
        itemWBContainer: {
            width: 350,
            height: 240,
            backgroundColor: '#fff',
            display: 'flex',
            flexDirection: 'column',
            rowGap: 12
        },
        wbThumbnail: {
            flex: 1,
            cursor: 'pointer',
            border: '1px solid #44494d',
            borderRadius: 12,
            overflow: 'hidden',
            position: 'relative',
            '&:hover': {
                borderColor: theme.palette.borderHover
            }
        },
        wbSelected: {
            borderStyle: 'dashed',
            borderColor: theme.palette.borderHover
        },
        wbLabel: {
            height: 24,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'start',
            fontWeight: 600,
            '@media (min-width: 540px)': {
                flexDirection: 'row',
                alignItems: 'center',
            }
        },
        wbTitle: {
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
            minHeight: 24,
            '@media (min-width: 540px)': {
                width: '50%',
            }
        },
        wbTitleCreate: {
            display: 'block',
            textAlign: 'center',
            width: '100%'
        }
    };
});
const ItemWhiteboard = ({ whiteboard, handleChooseWhiteboard, isDefault, isSelected }) => {
    const { cx, classes } = useStyles();
    const { t } = useTranslation();
    const [preview, setPreview] = useState('');
    const getPreview = async () => {
        try {
            const res = await apiManagerWB.fetchData(`${API_WHITEBOARD}/preview/${whiteboard?.white_board_id}`);
            setPreview(res);
        }
        catch (error) {
            console.log('[debugger] errr', error);
        }
    };
    useEffect(() => {
        !isDefault && getPreview();
    }, []);
    return (React.createElement("div", { className: cx(classes.itemWBContainer) },
        React.createElement("div", { className: cx(classes.wbThumbnail, isSelected && classes.wbSelected), onClick: () => handleChooseWhiteboard(whiteboard) },
            React.createElement("div", { dangerouslySetInnerHTML: {
                    __html: preview
                } }),
            isDefault && React.createElement(IconAddWhiteboard, null)),
        React.createElement("div", { className: cx(classes.wbLabel) },
            isDefault && React.createElement("span", { className: cx(classes.wbTitleCreate) }, t('whiteboard.create')),
            whiteboard && React.createElement(React.Fragment, null,
                React.createElement(Tooltip, { content: whiteboard.name, containerClassName: cx(classes.wbTitle) },
                    React.createElement("span", null, whiteboard.name)),
                React.createElement("span", null, formatDate(whiteboard.created_date))))));
};
function formatDate(date) {
    if (date) {
        var options = {
            hour: "2-digit",
            minute: "2-digit",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        };
        // Transfer UTC to local date and format them as British standard
        var localDate = new Date(date).toLocaleDateString("en-GB", options);
        // Swap the hour min and day month year when return
        return localDate.slice(12) + " " + localDate.slice(0, 10);
    }
    else
        return "";
}
;
export default ItemWhiteboard;
